// msh-quantity-stepper.component.ts
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ButtonComponent } from "./button.component";

@Component({
  selector: 'msh-quantity-stepper',
  standalone: true,
  imports: [FormsModule, MatIconModule, MatButtonModule, ButtonComponent],
  template: `
  @if(confirmRemove){
    <div class="flex w-36  flex-col items-center">
      <msh-button
        [cta]="'Remove'"
        (onClick)="onRemove.emit()"
      ></msh-button>
      <div (click)="confirmRemove = false" class="cursor-pointer text-navy-300 hover:text-navy ">cancel</div>
    </div>
  } @else {
    <div class="inline-flex items-center border w-36 rounded-md overflow-hidden select-none">
      <div
        [class]=" (value <= min ? ' opacity-50':' cursor-pointer') + ' px-3 py-1 text-lg leading-none min-w-[2.5rem] disabled:opacity-50'"
        (click)="decrement()"
        aria-label="Decrease quantity">
        <mat-icon class="text-lg">remove</mat-icon>
      </div>

      <input
        type="number"
        class="w-12 !m-0 !border-t-0 !border-b-0 !rounded-none bg-back text-center p-1 outline-none"
        [value]="value"
        (input)="onInput($event)"
        [min]="min"
        [max]="max"
        aria-label="Quantity" />

      <div
        [class]="(value >= max ? ' opacity-50' : ' cursor-pointer') + ' px-3 py-1 text-lg leading-none min-w-[2.5rem] disabled:opacity-50'"
        (click)="increment()"
        aria-label="Increase quantity">
        <mat-icon class="text-lg">add</mat-icon>
      </div>
    </div>
  }
  `,
  styles: [`
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
  `]
})
export class QuantityStepperComponent {
  @Input() value = 1;
  @Input() min = 1;
  @Input() max = 999;
  @Input() removable = false;
  @Output() valueChange = new EventEmitter<number>();
  @Output() onRemove = new EventEmitter<void>();
  confirmRemove: boolean = false;
  // FIXME add loading

  private clamp(v: number) {
    if (isNaN(v)) return this.min;
    return Math.max(this.min, Math.min(this.max, Math.floor(v)));
  }

  emit(v: number) {
    const n = this.clamp(v);
    this.value = n;
    this.valueChange.emit(this.value);
  }

  increment() { this.checkVal(1); }
  decrement() { this.checkVal(-1); }
  checkVal(movement = 0) { 
    const newValue = this.value + movement;
    this.confirmRemove = newValue === 0 && this.removable 
    if(!this.removable || newValue !== 0) this.emit(newValue)
  }

  onInput(e: Event) {
    const val = Number((e.target as HTMLInputElement).value);
    this.emit(val);
  }
}
